import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { UserPreference } from 'tuapath-common/generated/schema';

type Results = { userPreference: UserPreference[] };
type Variables = { userId: number, keys: string[] };

export const useUserPreferences = (options: QueryHookOptions<Results, Variables>) => {
  const query = gql`
    query GetUserPreferences($userId: Int!, $keys: [String!]!) {
      userPreference(userId: $userId, keys: $keys) {
        key
        value
      }
    }
  `;

  return useQuery<Results, Variables>(query, options);
};

export default useUserPreferences;
